import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import DictRow from './DictRow';

export default function Dictionary() {

    const [dictList, setDictList] = useState([]);
    const [loading, setLoading] = useState(false);
    const textRef = useRef()

    useEffect(() => {
        setLoading(true)
      axios.get("/dictionary/listing")
      .then(response=>{
          if(response?.data){
            let result = response.data;
            setDictList(result)
            setLoading(false)
            //console.log("response", result)
          }
      })
      .catch(error=> console.log(error))
    }, []);

    const searchDict=()=>{
        setLoading(true)
        let query = textRef.current.value;
        query = query.trim()
        axios.post("/dictionary/search", {query:query})
        .then(response=>{
            if(response?.data){
                let result = response.data;
                setDictList(result)
                setLoading(false)
                //console.log("response", result)
            }
        })
        .catch(error=> console.log(error))
    }
    

  return <>
        <div className='row'>
            <div className='col-lg-4 col-8 entryHead dateFilter'>
                <input type="text" ref={textRef} className='form-control' onKeyUp={()=>searchDict()} />
            </div>
            <div className='col-lg-2 col-4 entryHead'>
                <button type="button" className="btn btn-warning largeBtn btnCenter" onClick={()=>searchDict()}>Search</button>
            </div>
        </div> 
        <div className='row'>
            <div className='col-lg-3 col-6 entryHead'>Word</div>
            <div className='col-lg-3 col-6 entryHead'>Meaning</div>
            {/* <div className='col-lg-2 col-4 entryHead'>Detail</div> */}
        </div>
        {
            (!loading) ?
            dictList.map((data, key)=>{
                return <DictRow {...data} key={key}/>
            })
            :
            <Skeleton count={10} />
        }
  </>;
}
